import React from 'react';
import { FaEye } from 'react-icons/fa';

export default function IconEye({ size = 16, className = '', ...props }) {
  return (
    <FaEye
      size={size}
      className={`text-gray-500 hover:text-green-600 ${className}`}
      {...props}
    />
  );
}